<div class="container constrained ml-auto mr-auto">

    <div class="back-btn color-primary mb-2">
        <button id="btn_1693299026" ui-button model="clear" color="primary" (click)="goBack()">
            <em class="connect_icon_arrow_back mr-1 b2"></em> {{'privacy.back'|translate}}
        </button>
    </div>

    <div class="row">
        <!-- Error state -->
        <empty-state class="col" maxWidth="800px" [image]="privacyValuesService.images.errorState.link"
            imgMaxWidth="380px" [title]="'privacy.errorstate.title'| translate"
            [details]="'privacy.errorstate.description'| translate"
            *ngIf="errorState"></empty-state>

        <div class="col-12 col-lg-8 mb-3" *ngIf="article && !errorState">
            <ui-card type="raised" class="article">
                <card-body>
                    <p id="p_1668782532" class="c1 color-shade-70 medium mt-2 uppercase">
                        {{'privacy.education.published'|translate}}:
                        {{article.publish_date | localizedDate: 'mediumDate': true}}
                        | {{'privacy.education.topic.'+article.topic|translate}}
                    </p>
                    <h2 id="h2_1693298481" class="my-1">{{article.title}}</h2>
                    <div class="article-text" [innerHTML]="article.content"></div>
                </card-body>
            </ui-card>
        </div>


        <div class="col-12 col-lg-4">
            <privacy-education-aside *ngIf="article" [filter]="article?.topic"></privacy-education-aside>
        </div>
    </div>

</div>